import React, { Component } from 'react';
import DeviceGuidelinesForm from './DeviceGuidelinesForm';
import { fromJS } from 'immutable';
import moment from 'moment';

class DeviceGuidelines extends Component {
    componentDidMount = () => {
        this.props.getGuidelines();
    };

    onFormSubmit = values => {
        values = values.toJS();
        delete values.data_formats;
        values.stocktaking_setting.default_admission_day = moment(
            values.stocktaking_setting.default_admission_day
        ).format('YYYY-MM-DD');
        this.props.updateGuidelines({ setting: values, id: values.id });
    };

    render() {
        const bar_code_type_names = {
            all: 'Alle',
            code_128: 'Code 128',
            code_39: 'Code 39',
            code_93: 'Code 93',
            ean_13: 'EAN 13',
            ean_8: 'EAN 8',
            qr: 'QR',
            upc: 'UPC-A',
            itf: 'Interleave 2aus5',
        };

        return (
            <div>
                <h2>Gerätevorgaben</h2>
                <DeviceGuidelinesForm
                    onSubmit={this.onFormSubmit}
                    barCodeTypeNames={fromJS(bar_code_type_names)}
                    initialValues={this.props.device_guidelines}
                />
            </div>
        );
    }
}
export default DeviceGuidelines;
